import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from "motion/react";
import { ChevronLeftIcon } from '@/components/icons';

interface GalleryHeaderProps {
  clubName: string;
  clubHandle: string;
}

const GalleryHeader: React.FC<GalleryHeaderProps> = ({ clubName, clubHandle }) => {
  return (
    <motion.header 
      className="sticky top-0 z-40 bg-black/95 backdrop-blur-md border-b border-gray-800"
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Back Button */}
          <motion.div
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <Link
              to={`/venues/${clubHandle}`}
              className="flex items-center gap-2 text-gray-300 hover:text-white transition-all duration-300 group bg-black/20 hover:bg-black/40 backdrop-blur-sm rounded-full px-4 py-2 border border-gray-700 hover:border-gray-500"
            >
              <motion.div
                whileHover={{ x: -2, rotate: -2 }}
                transition={{ duration: 0.2 }}
              >
                <ChevronLeftIcon className="w-5 h-5" />
              </motion.div>
              <span className="text-sm font-medium">Back to Club</span>
            </Link>
          </motion.div>

          {/* Club Name */}
          <motion.div
            className="flex-1 text-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            <h1 className="text-xl font-semibold text-white truncate">
              {clubName} Gallery
            </h1>
          </motion.div>

          {/* Spacer for centering */}
          <div className="w-32" />
        </div>
      </div>
    </motion.header>
  );
};

export default GalleryHeader;
